import { render, staticRenderFns } from "./MentorsSuggestionsList.vue?vue&type=template&id=3e3ee479&"
import script from "./MentorsSuggestionsList.vue?vue&type=script&lang=js&"
export * from "./MentorsSuggestionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports